<template>
  <div class="countDetail container">
    <div class="searchBox">
      <div>
        <el-button size="mini" class="btn" type="primary" v-acl="CalculatesSave" @click="savecount('formTable')">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
      </div>
      <el-form label-width="120px" ref="applyInfoForm" :model="queryCondition" inline class="topform">
        <el-form-item :label="$t('apply.no')" prop="calculateNo">
          <el-input class="handle-input" v-model="queryCondition.calculateNo" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.remarks')" prop="remark">
          <el-input class="handle-input" v-model="queryCondition.remark"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="toolsBox">
      <el-button type="primary" v-acl="CalculatesDetailAdd" @click="showApplyLineAddDialogFunc()" size="mini">新增</el-button>
      <el-button type="danger" v-acl="CalculatesDelete" @click="delLine('formTable')" size="mini">{{$t("common.del")}}</el-button>
    </div>
    <el-form ref="formTable" :rules="rules" :model="formTable">
      <el-table :data="formTable.tableDetail" border highlight-current-row>
        <el-table-column fixed width="56" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio class="radio" @change.native="getCurrentRow(scope.$index)" v-model="radioVal" :label="scope.$index" />
          </template>
        </el-table-column>
        <el-table-column sortable prop="tmPickupId" label="提货点" min-width="100px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.tmPickupId' " :rules="rules.tmPickupId">
              <ic-select :filterable="true" :clearable="true" table="BASE" field="PICKUP_POINT" v-model="scope.row.tmPickupId" @check="changeDc($event,scope.$index)" :disabled="disableEditor"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column sortable prop="tmDcId" label="到货仓库（DC）" min-width="180px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.tmDcId' " :rules="rules.tmDcId">
              <ic-select :filterable="true" :clearable="true" table="BASE" field="DC" v-model="scope.row.tmDcId" @check="changeDc($event,scope.$index)" :disabled="disableEditor"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column sortable prop="temperature" label="温区" min-width="100px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.temperature' " :rules="rules.temperature">
              <ic-select :filterable="true" :clearable="true" table="COMMON" field="TEMPERATURE" v-model="scope.row.temperature" @check="changeDc($event,scope.$index)" :disabled="disableEditor"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="transportaionMethod" sortable label="运输方式" min-width="100px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.transportaionMethod' " :rules="rules.transportaionMethod">
              <ic-select :filterable="true" :clearable="true" table="COMMON" field="TRANSPORTAION_METHOD" v-model="scope.row.transportaionMethod" @check="changeDc($event,scope.$index)" :disabled="disableEditor"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="linePrice" sortable label="线路价格" min-width="100px">
          <template slot-scope="scope">
            <el-form-item>
              <el-input :disabled="!saveSubmitBtnShow" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" v-model="scope.row.linePrice" @blur="blurLinePrice('tableDetail.'+ scope.$index + '.lineUnit' )"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="lineUnit" sortable label="结算单位" min-width="120px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.lineUnit' " :rules="scope.row.linePrice == '' ? [] : rules.lineUnit">
              <ic-select table="COMMON" field="UNIT" v-model="scope.row.lineUnit" @blur="changeLineUnit(scope.$index,scope.row.lineUnit)" @change="changeLineUnit(scope.$index,scope.row.lineUnit)"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="productPrice" sortable width="170" label="产品运费（不含税）">
          <template slot-scope="scope">
            {{calculate(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column sortable prop="externalPackagingLength" label="外包装长(cm)" min-width="120px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.externalPackagingLength' " :rules="rules.externalPackagingLength">
              <el-input type="number" v-model="scope.row.externalPackagingLength"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column sortable prop="externalPackagingWidth" label="外包装宽(cm)" min-width="120px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.externalPackagingWidth' " :rules="rules.externalPackagingWidth">
              <el-input type="number" v-model="scope.row.externalPackagingWidth"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column sortable prop="externalPackagingHeight" label="外包装高(cm)" min-width="120px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.externalPackagingHeight' " :rules="rules.externalPackagingHeight">
              <el-input type="number" v-model="scope.row.externalPackagingHeight"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column sortable prop="externalPackagingNetweight" label="外包装净重(kg)" min-width="130px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.externalPackagingNetweight' " :rules="rules.externalPackagingNetweight">
              <el-input type="number" v-model="scope.row.externalPackagingNetweight"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column sortable prop="externalPackagingGrossweight" label="外包装毛重(kg)" min-width="130px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.externalPackagingGrossweight' " :rules="rules.externalPackagingGrossweight">
              <el-input type="number" v-model="scope.row.externalPackagingGrossweight"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column sortable prop="palletLayerNumber" label="每Pallet层数" min-width="120px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.palletLayerNumber' " :rules="rules.palletLayerNumber">
              <el-input type="number" v-model="scope.row.palletLayerNumber"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column sortable prop="palletLayerBoxNumber" label="每层箱数" min-width="100px">
          <template slot-scope="scope">
            <el-form-item :prop=" 'tableDetail.' + scope.$index + '.palletLayerBoxNumber' " :rules="rules.palletLayerBoxNumber">
              <el-input type="number" v-model="scope.row.palletLayerBoxNumber"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <!-- 到货仓库 -->
    <el-dialog :visible.sync="showSelDcMultipleDialog" append-to-body width="80%">
      <SelDc ref="selectDcMultipleRef" :multipleSelectionFlag="false" @subCallMethod="selectDcMethod"></SelDc>
    </el-dialog>
  </div>
</template>
<script>
import {
  calculation,
  saveData,
  calculatesDetail,
  getMaterial
} from "@/api/quoteByProduct.js";
import { inputChoiceService } from "@/api/common/input-choice";
import SelDc from "@/components/page/base-data/dc-sel-page";

import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import dataTableUtils from "@/utils/dataTableUtils";
import { Message } from "element-ui";

let checkPrice = (rule, value, callback) => {
  let reg = /^(0|[1-9]\d{0,14})(\.\d{1,5})?$/;
  if (!reg.test(value)) {
    callback(new Error());
  } else {
    callback();
  }
};
export default {
  name: "productQuotationApplicationAdd",
  components: { IcSelect, SelDc },
  data() {
    let validateLength = (rule, value, callback) => {
      console.log(value)
    };
    return {

      rules: {
        tmPickupId: [//提货点
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        tmDcId: [//到货仓库
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        transportaionMethod: [//运输方式
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        temperature: [//温区
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }
        ],
        lineUnit: [//结算单位
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' },
        ],
        externalPackagingLength: [//外包装长
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        externalPackagingWidth: [//外包装宽
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        externalPackagingHeight: [//外包装高
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        externalPackagingNetweight: [//外包装净重
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        externalPackagingGrossweight: [//外包装毛重
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        palletLayerNumber: [//每Pallet层数
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
        palletLayerBoxNumber: [//每层箱数
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }
        ],
      },
      radioVal: null,
      saveSubmitBtnShow: true,
      formTable: {
        tableDetail: [],
      },
      queryCondition: {},
      ttCalculateId: null,
      submitBtnShow: false,
      selectRowIndex: null,
      disableEditor: false,
      showSelDcMultipleDialog: false,

      showUploadFlag: false,
      materialSearchForm: {
        eightBitCode: "",
        eightBitCodeName: "",
        plantNo: "",
        plantName: "",
        supplierCode: "",
        supplierName: "",
        pickupPoint: "",
        dcName: "",
        temperature: "",
        transportaionMethod: "",
        pageSize: 15,
        pageNum: 1,
        total: null,
      },
      transportaionMethodList: [],

      fileList: [],
      materialList: [],

      dialogVisible: false,
      SelectionChangeMateriaObj: [],
      page: {
        size: 10,
        current: 1,
        total: 0
      },
    };
  },
  computed: {
    // calculate() {
    //     return (row)=>{
    //         switch (row.lineUnit) {

    //             case "CBM":
    //                 return (row.linePrice * ((row.externalPackagingLength / 100) * (row.externalPackagingWidth / 100) * (row.externalPackagingHeight / 100))).toFixed(6);
    //             case "PLT":
    //                 return (row.linePrice / (row.palletLayerNumber * row.palletLayerBoxNumber)).toFixed(6);
    //             case "TON":
    //                 return (row.linePrice * (row.externalPackagingGrossweight / 1000)).toFixed(6);
    //         }
    //     }
    // },
    calculate() {
      return (row) => {
        switch (row.lineUnit) {
          case "CBM":
            let item1 = (row.linePrice * ((row.externalPackagingLength / 100) * (row.externalPackagingWidth / 100) * (row.externalPackagingHeight / 100))).toFixed(6)
            if (this.isNumber(item1)) {
              return item1;
            } else {
              return "0.000000";
            }
          case "PLT":
            let item2 = (row.linePrice / (row.palletLayerNumber * row.palletLayerBoxNumber)).toFixed(6)
            if (this.isNumber(item2)) {
              return item2;
            } else {
              return "0.000000";
            }
          case "TON":
            let item3 = (row.linePrice * (row.externalPackagingGrossweight / 1000)).toFixed(6)
            if (this.isNumber(item3)) {
              return item3;
            } else {
              return "0.000000";
            }
        }
      }
    },
  },
  created() {
    this.ttCalculateId = this.$route.query.ttCalculateId;
    if (this.$route.query.ttCalculateId != -1) {
      this.getPageInit(this.$route.query.ttCalculateId);
    }
    // this.fatchMaterial();
  },
  watch: {
    '$route.query'(to, from) {
      let ttCalculateId = this.$route.query.ttCalculateId;
      if (ttCalculateId != -1) {
        this.getPageInit(ttCalculateId);
      }
    },
  },
  methods: {
    getPageInit: function (ttCalculateId) {

      calculatesDetail(ttCalculateId).then(res => {
        this.queryCondition = res.data;
        this.formTable.tableDetail = res.data.details;
        this.$nextTick(() => {
          this.$refs.formTable.clearValidate();
        })
      });
    },
    getCurrentRow(index) { },
    showApplyLineAddDialogFunc() {
      // this.dialogVisible = true;
      let length = this.formTable.tableDetail.length;
      var list = {};
      if (this.formTable.tableDetail == null) {
        this.formTable.tableDetail = [];
        this.formTable.tableDetail.push(list);
      } else {
        this.formTable.tableDetail.push(list);
      }
    },
    changeDc(dc, rowIndex) {
      let that = this;
      let data = this.formTable.tableDetail[rowIndex];
      if (commonFun.isNotEmpty(data.transportaionMethod) && commonFun.isNotEmpty(data.tmDcId) && commonFun.isNotEmpty(data.tmPickupId) && commonFun.isNotEmpty(data.temperature)) {
        data.unit = null;
        data.linePrice = null;
        calculation(data).then(response => {
          response.ttCalculateDetailId = that.formTable.tableDetail[rowIndex].ttCalculateDetailId;
          that.$set(that.formTable.tableDetail, rowIndex, response);
        });
      }
    },
    delLine(formName) {
      if (this.radioVal == null) {
        Message.error(this.$t('common.pleaseSelectOneData'));
        return;
      }
      this.formTable.tableDetail.splice(this.radioVal, 1);
      this.radioVal = null;
    },
    blurLinePrice(val) {
      this.$refs.formTable.validateField(val);
    },
    changeLineUnit(index, val) {
      switch (val) {
        case "PLT":
          //Pallet
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingLength');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingWidth');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingHeight');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingNetweight');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingGrossweight');
          this.$refs.formTable.validateField('tableDetail.' + index + '.palletLayerNumber');
          this.$refs.formTable.validateField('tableDetail.' + index + '.palletLayerBoxNumber');
          break;
        case "TON":
          //吨
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingLength');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingWidth');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingHeight');
          this.$refs.formTable.validateField('tableDetail.' + index + '.externalPackagingNetweight');
          this.$refs.formTable.validateField('tableDetail.' + index + '.externalPackagingGrossweight');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.palletLayerNumber');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.palletLayerBoxNumber');
          break;

        case "CBM":
          //立方米
          this.$refs.formTable.validateField('tableDetail.' + index + '.externalPackagingLength');
          this.$refs.formTable.validateField('tableDetail.' + index + '.externalPackagingWidth');
          this.$refs.formTable.validateField('tableDetail.' + index + '.externalPackagingHeight');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingNetweight');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.externalPackagingGrossweight');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.palletLayerNumber');
          this.$refs.formTable.clearValidate('tableDetail.' + index + '.palletLayerBoxNumber');
          break;

      }
    },
    //保存
    savecount(formName) {
      let that = this;
      if (that.formTable.tableDetail < 1) {
        that.$message({ message: this.$t("sensory.template.PleaseMaintainDetailLine"), type: "warning" });
        return;
      }
      let data = {};
      if (that.ttCalculateId != -1) {
        data.ttCalculateId = that.ttCalculateId;
      }
      data.remark = that.queryCondition.remark;
      data.details = that.formTable.tableDetail;
      data.details.forEach(row => {
        if (that.isNumber(this.calculate(row))) {
          row.productPrice = that.calculate(row)
        } else {
          row.productPrice = ''
        }
      });
      saveData(data, that.ttCalculateId).then(res => {
        that.$message({ message: this.$t("common.success"), type: "success" });
        if (that.ttCalculateId == -1) {
          that.ttCalculateId = res.data.ttCalculateId;
          that.$router.push({
            path: `/count-datail`,
            query: {
              ttCalculateId: res.data.ttCalculateId,
            }
          });
        } else {
          that.getPageInit(that.ttCalculateId);
        }
      });
    },
    isNumber(val) {
      var reg = new RegExp("^(\\-)?\\d+(\\.\\d+)?$");
      if (!reg.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    showSelDcDialogFunc: function (method, row) {
      let that = this;
      if (!!row) {
        this.tempRows = row;
      } else {
        this.tempRows = null;
      }
      if ("1" == method) {
        if (!that.disableEditor) {
          //单选
          this.multipleSelectionBl = false;
          this.showSelDcMultipleDialog = true;
        }
      } else {
        this.multipleSelectionBl = true;
        this.showSelDcDialog = true;
      }
    },
    //到货仓库选择
    selectDcMethod: function (dcList) {
      let _this = this;
      if (this.multipleSelectionBl) {
        //多选
        let codes = new Array();
        let dcIds = new Array();
        dcList.forEach(item => {
          dcIds.push(item.tmDcId);
          codes.push(item.dcName);
        });
        _this.applyLineNew.dcName = codes.join(",");
        _this.applyLineNew.dcIds = dcIds;
      } else {
        //单选
        this.tempRows.tmDcId = dcList[0].tmDcId;
        this.tempRows.dcName = dcList[0].dcName;
        calculation(this.tempRows).then(res => {
          _this.$set(_this.formTable.tableDetail, _this.radioVal, res);
        });
      }
      this.showSelDcDialog = false;
      this.showSelDcMultipleDialog = false;


    },
    historyBack() {
      this.$router.go(-1);
    },
    // //查询8位码
    // fatchMaterial() {
    //     let that = this;
    //     let data = {
    //         eightBitCode: this.materialSearchForm.eightBitCode,
    //         eightBitCodeName: this.materialSearchForm.eightBitCodeName,
    //         plantName: this.materialSearchForm.plantName,
    //         plantNo: this.materialSearchForm.plantNo,
    //         supplierCode: this.materialSearchForm.supplierCode,
    //         supplierName: this.materialSearchForm.supplierName,
    //         pickupPoint: this.materialSearchForm.pickupPoint,
    //         dcName: this.materialSearchForm.dcName,
    //         temperature: this.materialSearchForm.temperature,
    //         transportaionMethod: this.materialSearchForm.transportaionMethod,
    //         pageSize: this.materialSearchForm.pageSize,
    //         pageNum: this.materialSearchForm.pageNum
    //     };
    //     getMaterial(data).then(res => {
    //         that.materialList = res.resultData;
    //         that.materialSearchForm.total = res.totalCount;
    //     });

    // },
    handleSizeChange(e) {
      this.page.size = e;
      // this.customer_list();
    },
    handleCurrentChange(e) {
      this.page.current = e;
      //  this.customer_list();
    },
    handleSelectionChange(row) {
      console.log(row);
    },
    handleSelectionChangeMateria(val) {
      this.SelectionChangeMateriaObj = val;

    }
  },
  extends: dataTableUtils,
};
</script>
<style scoped lang="scss">
.countDetail {
  .toolsBox {
    margin-bottom: 10px;
  }

  .a-link {
    text-decoration: underline;
  }

  .topform {
    margin-top: 20px;
  }
}
</style>
<style  lang="scss">
</style>
